import React from 'react';
import { Modal } from 'semantic-ui-react';
import ImgPopupPottencialModal from '../../../../resources/imgs/popup-pottencial-promotion.png';

interface PottencialPromotionModalInterface {
  open: boolean;
  onClose: () => void;
}

const PottencialPromotionModal = ({
  open,
  onClose
}: PottencialPromotionModalInterface) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      size="small"
      closeOnEscape={true}
      closeOnTriggerClick={true}
      closeOnDocumentClick={false}
      closeOnDimmerClick={true}
      style={{ width: '500px', height: '705px', padding: '0', borderRadius: '8px' }}
      closeIcon
    >
      <Modal.Content
        style={{ width: '500px', height: '705px', padding: '0', borderRadius: '8px' }}
      >
        <img src={ImgPopupPottencialModal} style={{ width: '500px', height: '705px' }} />
      </Modal.Content>
    </Modal>
  );
};

export default PottencialPromotionModal;
